import { WishlistActions } from '../wishlist/types';
import { useNotificationManager } from './hooks';
import { NotificationPayload, NotificationPosition } from './types';

export const showNotificationWishlist = (payload: NotificationPayload) => {
  useNotificationManager.getState().pushNotification({
    name: WishlistActions.ADD,
    position: NotificationPosition.BOTTOM,
    payload,
  });
};
